module.exports = __webpack_public_path__ + "static/media/swap-horizontal.58a4c8fa.svg";